<template>
  <el-dialog title="选择地址" :visible.sync="showMap" :append-to-body="false" :modal="false" width="500px" custom-class="mapClass"
    style="min-width: 800px;">
    <div class="address-page">

      <!-- 地图 -->
      <div class="map-view">
        <div class="info">
          <div class="input-item">
            <input id="tipinput" type="text" placeholder="搜索地点" />
          </div>
        </div>

        <div id="container" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.3)" class="map"></div>

        <div class="SockBox">
          <el-form ref="form" :model="addQuery" :rules="rules" label-width="120px" label-position="left"
            @submit.native.prevent>
            <el-form-item label="地点名称" prop="address">
              <el-input v-model="addQuery.address" style="width: 400px;" placeholder="请输入地点名称"></el-input>
            </el-form-item>

            <el-form-item v-if="mapShowType != 'org_address'" :label="(mapShowType == 'address' || mapShowType == 'qiandao') ? '签到范围' : '签退范围'" prop="signin_distance">
              <el-select v-model="addQuery.signin_distance" placeholder="请选择" style="width: 400px;" @change="signSelect">
                <el-option v-for="item in signInMiList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>

        <div class="bottom">
          <el-button class="absbtn" @click="onCancel">
            取消
          </el-button>
          <el-button class="absbtn" type="primary" @click="onSubmit">确认
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import waves from '@/directive/waves'
import AMapLoader from '@amap/amap-jsapi-loader'
export default {
  name: 'Amap',
  directives: { waves },
  components: {},
  props: {
  },
  data() {
    return {
      mapShowType: "",
      signDistance: 0,
      signAddress: "",
      showMap: false,
      loading: true,
      signInMiList: [{
        label: "50米",
        value: 50
      }, {
        label: "100米",
        value: 100
      }, {
        label: "200米",
        value: 200
      }],
      rules: {
        address: [{ required: true, message: "请输入", trigger: "blur" }],
        signin_distance: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      addQuery: {
        signin_distance: 0,
        address: "",

      },
      map: null,
      lng: 120.699367,
      lat: 27.993897,
      isMap: false,
      mapObj: null,
      marker: null,
      addrData: {},
      fujinList: [],
      circleobj: null,
      circleRadius: {
        50: 18,
        100: 17,
        200: 16,
        500: 15
      }
    }

  },
  created() {
  },
  mounted() {
    // this.initMap()
  },
  methods: {
    //选中签到范围
    signSelect(e) {
      this.circleobj.setRadius(e)
      this.mapObj.setZoom(this.circleRadius[e])
    },
    initMap(mapShowType, signin_distance, address, lng, lat) {
      this.mapShowType = mapShowType
      this.showMap = true
      this.addQuery = {
        signin_distance,
        address,
      }
      this.lng = lng || 120.699367
      this.lat = lat || 27.993897

      window._AMapSecurityConfig = {
        securityJsCode: "581a8597882e621b6537a2bd3324e93d",
      };

      console.log(lng, lat, '9999999999999999999999')
      AMapLoader.load({
        key: 'b114b461abee8f7dac4c60ecc3828b78', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '1.4.15', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
          'AMap.Autocomplete',
          'AMap.PlaceSearch',
          'AMap.geoCoder',
          'AMap.Geolocation' // 定位
        ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        AMapUI: {
          // 是否加载 AMapUI，缺省不加载
          version: '1.1', // AMapUI 缺省 1.1
          plugins: [] // 需要加载的 AMapUI ui插件
        },
        Loca: {
          // 是否加载 Loca， 缺省不加载
          version: '1.3.2' // Loca 版本，缺省 1.3.2
        }
      })
        .then((AMap) => {

          console.log(AMap, 'AMapAMapAMapAMap')

          this.map = AMap
          this.createMap()
        })
        .catch((e) => {
          console.log(e)
          this.initMap(this.mapShowType, this.addQuery.signin_distance, this.addQuery.address, this.lng, this.lat)
        })
    },
    ChangeAddress(item) {
      console.log(item)
      console.log('地址e====', item)

      this.lng = item.location.lng
      this.lat = item.location.lat
      this.addQuery.address = item.address;
      // this.marker.setPosition([this.lng, this.lat]);

      // // 将创建的点标记添加到已有的地图实例：
      // this.mapObj.add(this.marker)
      this.mapObj.setZoom(17)
      this.mapObj.setCenter([this.lng, this.lat])
    },
    createMap() {
      var that = this

      const locationIcon = {
        showButton: true, // 是否显示定位按钮
        buttonPosition: 'RB', // 定位按钮的位置
        /* LT LB RT RB */
        buttonOffset: new AMap.Pixel(10, 50), // 定位按钮距离对应角落的距离
        showMarker: false, // 是否显示定位点
        showCircle: true, // 是否显示定位精度圈
        circleOptions: {
          // 定位精度圈的样式
          strokeColor: '#f00',
          noSelect: true,
          strokeOpacity: 0.5,
          strokeWeight: 1,
          fillColor: '#f00',
          fillOpacity: 0.8
        },
      }

      that.mapObj = new that.map.Map('container', {
        resizeEnable: true,
        center: [that.lng, that.lat],
        pitch: 60,
        zoom: this.circleRadius[this.addQuery.signin_distance],
        zooms: [15, 18]
      })

      // 创建一个 Marker 实例：
      // that.marker = new AMap.Marker({
      //   // 设置是否可以拖拽
      //   // draggable: true,
      //   // cursor: 'move',
      //   position: new AMap.LngLat(that.lng, that.lat) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      // })

      var circle = new AMap.Circle({
        center: [that.lng, that.lat],
        radius: this.addQuery.signin_distance, //半径
        borderWeight: 3,
        strokeColor: "#1791fc",
        strokeWeight: 1,
        strokeOpacity: 0.8,
        fillOpacity: 0.3,
        fillColor: '#1791fc',
        zIndex: 50,
      })
      // // 设置圆形
      that.circleobj = circle
      // 设置圆形
      that.mapObj.add(circle);


      // 将创建的点标记添加到已有的地图实例
      // that.mapObj.add(that.marker)
      // that.searchNearBy(new AMap.LngLat(that.lng, that.lat));

      // 实例化一个定位
      const geolocation = new AMap.Geolocation(locationIcon)
      that.mapObj.addControl(geolocation)
      geolocation.getCurrentPosition()

      // 定位成功后回调
      AMap.event.addListener(geolocation, 'complete', function (data) {
        if (data.info === 'SUCCESS') {
          console.log('获取定位成功')
          console.log(data) // 这里是定位成功后的输出数据
        }
      })
      // 定位失败回调
      AMap.event.addListener(geolocation, 'error', function (data) {
        console.log('获取当前定位失败')
      })



      this.loading = false

      AMapUI.loadUI(['misc/PositionPicker'], function (PositionPicker) {
        // 实例化Autocomplete
        var autoOptions = {
          // input 为绑定输入提示功能的input的DOM ID
          input: 'tipinput'
        }
        var autoComplete = new AMap.Autocomplete(autoOptions)

        AMap.event.addListener(autoComplete, 'select', that.selectMap) // 注册监听，当选中某条记录时会触发



        // that.marker.on('dragend', function (e) {
        //   console.log('坐标', that.marker.getPosition())
        //   const res = that.marker.getPosition()
        //   that.circleobj.setCenter(new AMap.LngLat(res.lng, res.lat))
        //   that.circleobj.setRadius(100)
        //   that.toGeoCoder(res.lng, res.lat);
        // });

        // that.marker.setMap(that.mapObj);


        // 拖拽选点
        var positionPicker = new PositionPicker({
          mode: 'dragMarker', // 设定为拖拽地图模式，可选'dragMap'、'dragMarker'，默认为'dragMap'
          map: that.mapObj // 依赖地图对象
        })

        // positionPicker.setMode(e.target.value)

        // console.log('positionPicker====', positionPicker)

        positionPicker.on('success', function (positionResult) {
          console.log('拖拽地址获取成功=====', positionResult)
          that.lng = positionResult.position.lng
          that.lat = positionResult.position.lat
          that.addQuery.address = positionResult.address
          that.addrData = positionResult.regeocode.addressComponent
          // that.fujinList = positionResult.regeocode.pois
          // that.marker.setPosition([that.lng, that.lat]);
          that.circleobj.setCenter(new AMap.LngLat(that.lng, that.lat))
          that.mapObj.setCenter(new AMap.LngLat(that.lng, that.lat))


        })

        positionPicker.on('fail', function (positionResult) {
          console.log('拖拽地址获取失败===', positionResult)
        })

        positionPicker.start()
      })

      this.mapObj.on('click', function (ev) {
        console.log(ev)
        // 触发事件的对象
        // var target = ev.target;
        // 触发事件的地理坐标，AMap.LngLat 类型
        // var lnglat = ev.lnglat;
        // 触发事件的像素坐标，AMap.Pixel 类型
        // var pixel = ev.pixel;
        // 触发事件类型
        // var type = ev.type;
        const lnglat = ev.lnglat;
        that.lng = lnglat.lng
        that.lat = lnglat.lat
        that.createMap()
        // that.searchNearBy(ev.lnglat);
        // that.marker.setPosition([lnglat.lng, lnglat.lat]);
      });
    },

    // 监听地图搜索
    selectMap(e) {
      // this.mapObj.remove(this.marker)
      if (e.poi.location) {
        //定位到中心点
        this.lng = e.poi.location.lng
        this.lat = e.poi.location.lat
        this.createMap()
      }


      return
      // // 创建一个 Marker 实例：
      this.marker = new AMap.Marker({
        position: new AMap.LngLat(this.lng, this.lat)
      })

      // // 将创建的点标记添加到已有的地图实例：
      this.mapObj.add(this.marker)
      // this.mapObj.setZoom(17)
      this.mapObj.setCenter([this.lng, this.lat])

      this.circleobj.setCenter(new AMap.LngLat(this.lng, this.lat))

    },
    searchNearBy(lnglat) {
      const that = this;
      const placeSearch = new AMap.PlaceSearch({
        // city 指定搜索所在城市，支持传入格式有：城市名、citycode和adcode
        // city: '010'
      })

      // const center = new AMap.LngLat(this.lng, this.lat);
      placeSearch.searchNearBy('', lnglat, 50000, function (status, result) {
        // 查询成功时，result即对应匹配的POI信息
        console.log(status, result);
        if (status === 'complete') that.fujinList = result.poiList.pois || [];
      })
    },
    onCancel() {
      // this.$emit('onCancel')
      this.showMap = false
    },
    // 确认地址
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("xooiuujj", {
            address: this.addQuery.address,
            lng: this.lng,
            lat: this.lat,
            addrData: this.addrData,
            range: this.addQuery.signin_distance
          })
          this.$emit('onAddrConfirm', {
            address: this.addQuery.address,
            lng: this.lng,
            lat: this.lat,
            addrData: this.addrData,
            range: this.addQuery.signin_distance
          })
          this.showMap = false
        } else { }
      });
    }
  }
}
</script>

<style lang="less" scoped>
// .amap-sug-result {
//   z-index: 88888;
// }
.mapClass.el-dialog {
  min-width: 900px !important;
}

.mapClass .el-dialog__body {
  padding: 0;
}

.mapClass .el-dialog__header {
  padding: 15px !important;
}


.map-view {

  position: relative;

  .map {
    height: 450px;
    width: 100%;
    position: relative;

  }

  .info {
    z-index: 9999;
    position: absolute;
    left: 20px;
    top: 10px;
    height: 54px;
    overflow: hidden;
    width: 300px;


    .input-item {
      flex: 1;
      display: flex;
      align-items: center;

      input {
        flex: 1;
        border: none;
        border: 1px solid #f3f3f3;
        background: #fff;
        border-radius: 5px;
        outline: none;
        display: block;
        height: 40px;
        padding: 0 8px;
        color: #454545;
        font-size: 14px;
      }
    }
  }
}

.SockBox {
  padding: 15px 15px 0;
  border-bottom: 1px solid #f5f5f5;
}

.bottom {
  padding: 15px;
  background: #ffffff;
  text-align: right;

  .absbtn {
    margin-left: 15px;
  }
}
</style>
